export default {
  party_id: "SUPERPARTYTEST9",
  state: "live",
  title: "Bleach and Friends",
  image_url:
    "https://res.cloudinary.com/bleach-london/image/upload/c_scale,h_660/v1586419995/Hair-Party-Logo_zgw0tf.png",
  description: "Hair Party",
  start_time: "2020-04-11T16:00:00.000+00:00",
  end_time: "2020-04-11T20:00:00.000+00:00",
  shoppable_links: [
    {
      id: "5e8ef689c777cf465738b288",
      type: "bundle",
      title: "JUCIY PARTY",
      description:
        "The only one who could ever reach me, was the son of a peacher man... If you're ready for hair as juicy as a peach, then this is the pack for you.",
      image_url:
        "https://res.cloudinary.com/bleach-london/image/upload/c_crop,g_center,h_1000,w_1000/v1586422620/juicy_party_wkoi8r.jpg",
      target_url:
        "https://bleachlondon.co.uk/products/juicy-party-total-pack-1",
      alt_tag: "Buy the Juciy Party Pack"
    },
    {
      id: "5e8ef689c777cf465738b289",
      type: "bundle",
      title: "JUICE CLEANSE PARTY PACK",
      description:
        "So you went vegan and you want everyone to know? Let your lid do the talking with the Juice Cleanse Party Pack.",
      image_url:
        "https://res.cloudinary.com/bleach-london/image/upload/c_crop,g_center,h_1000,w_1000/v1586422620/juice-cleanse_z8vaaz.jpg",
      target_url:
        "https://bleachlondon.co.uk/products/juice-cleanse-party-total-pack",
      alt_tag: "Buy the Juice Cleanse Party Pack"
    },
    {
      id: "5e8ef689c777cf465738b28a",
      type: "bundle",
      title: "VIOLET FEMME PARTY PACK",
      description:
        "These violet delights have violet ends... Get purple haze for daze with the Violet Femme Party Pack.",
      image_url:
        "https://res.cloudinary.com/bleach-london/image/upload/c_crop,g_center,h_1000,w_1000/v1586422620/violet-femme_clz7sb.jpg",
      target_url: "https://bleachlondon.co.uk/products/violet-femme-total-pack",
      alt_tag: "Buy the Violet Femme Party Pack"
    },
    {
      id: "5e8ef689c777cf465738b28b",
      type: "bundle",
      title: "PINKCESS PARTY PACK",
      description:
        "If you've got pinky on the brain and wanna see it in the drain then pick up this Party Pack stat!",
      image_url:
        "https://res.cloudinary.com/bleach-london/image/upload/c_crop,g_center,h_1000,w_1000,x_0,y_0/v1586422620/pinkcess_wasehe.jpg",
      target_url:
        "https://bleachlondon.co.uk/products/pinkcess-party-total-pack",
      alt_tag: "Buy the Pinkcess Party Pack"
    },
    {
      id: "5e8ef689c777cf465738b28c",
      type: "chat",
      title: "Chatbot",
      description: "Chat with the Chatbot",
      image_url:
        "https://res.cloudinary.com/bleach-london/image/upload/c_scale,h_660/v1586419995/Hair-Party-Logo_zgw0tf.png",
      target_url: "https://chat.bleachlondon.com",
      alt_tag: "Chat with the chatbot"
    }
  ],
  pusher: {
    app_id: "973321",
    cluster: "eu",
    channel_id: "wvpsrslcfg"
  },
  live_stream:
    "https://cdn3.wowza.com/1/YVpQSFZJMkwrRnpI/bklRejJH/hls/live/playlist.m3u8",
  attending: false
}
